import { render, staticRenderFns } from "./booking-balance.vue?vue&type=template&id=62b870a8&"
import script from "./booking-balance.vue?vue&type=script&lang=js&"
export * from "./booking-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports